import { EventEmitter, Output } from "@angular/core";
import { HttpService } from "../core/http/http.service";
import { ModelStateValidationService } from "./model-state-validation.service";
import { CrudOperation, IDataAccessEvent, IDataChangeCallback } from "../_entities/data";

export abstract class DataAccessServiceBase<T> {
    
    @Output() itemChanged = new EventEmitter<IDataAccessEvent<T>>();

    protected item = {} as T;

    protected constructor(protected httpService: HttpService,
        protected validationService: ModelStateValidationService) {
    }

    abstract getControllerUrl(): string;

    getItems(): Promise<T[] | any> {
        return this.httpService.get(this.getControllerUrl())
            .catch(e => {
                this.validationService.handleError(e);
            });
    }

    getItem(id: any | string): Promise<T | any> {
        var idParam = this.getIdParam(id);
        return this.httpService.get(`${this.getControllerUrl()}/${idParam}`)
            .catch(e => {
                this.validationService.handleError(e);
            });
    }

    patchItem(id: any, patches: any[], oldValue?: any): Promise<T | any> {
        var idParam = this.getIdParam(id);
        this.replaceObjectPaths(patches);
        const newValue = patches[0].value;
        const fieldName = patches[0].path.substring(1);

        return this.httpService.patch<T>(`${this.getControllerUrl()}/${idParam}`, patches)
            .then((updatedItem) => {
                this.itemChanged.emit({ operation: CrudOperation.Update, data: updatedItem, newValue: newValue, oldValue: oldValue, fieldName: fieldName});
                return Promise.resolve(updatedItem);
            });
    }

    addItem(item: T): Promise<T | any> {
	    return this.httpService.post<T>(this.getControllerUrl(), item)
		    .then((newItem) => {
			    this.itemChanged.emit({ operation: CrudOperation.Create, data: newItem });
			    return Promise.resolve(newItem);
		    });
    }

    deleteItem(id: any): Promise<void> {
        var idParam = this.getIdParam(id);
	    return this.httpService.delete<void>(`${this.getControllerUrl()}/${idParam}`)
		    .then(() => {
			    this.itemChanged.emit({ operation: CrudOperation.Delete, data: null });
			    return Promise.resolve();
		    });
    }


    isDataChangeCallback(object: any): object is IDataChangeCallback<any> {
        return 'fieldname' in object;
    }


    getType(): string {
        return typeof this.item;
    }

    replaceObjectPaths(patches: any[]): void {
        for (let patch of patches) {
            patch.path = patch.path.replace(/\./g, "/");
        }

    }

    private getIdParam(id: any) {
        if (id == null) return null;
        return (typeof id == 'string' && id.length == 0) ? "empty_string" : id;
    }

}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/dataaccess.base.service.ts